import React, { useEffect, useState } from "react";
import {
  Container,
  Checklist,
  Danger,
  Cross,
  NotificationText,
  SuccessOption,
  Exclamation,
  RightMessage,
} from "./_snackbarStyle";

type Props = {
  type?: "success" | "error" | "warning";
  show?: boolean;
  undoable?: boolean;
  onUndo?: React.MouseEventHandler;
  onClose?: () => void;
  message?: string;
  delay?: number;
  delayable?: boolean;
  rightMessage?: string;
  onClickRightMessage?: React.MouseEventHandler;
  "data-testid"?: string;
  actionButton?: React.ReactNode;
};

function Snackbar(props: Props) {
  const {
    show,
    type,
    onClose,
    undoable,
    onUndo,
    message,
    delay,
    delayable,
    rightMessage,
    onClickRightMessage,
    "data-testid": dataTestId = "snackbar",
    actionButton,
    ...rest
  } = props;

  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    let timer: any;

    if (delay && delayable && show && message && message !== "") {
      setShowSnackbar(true);
      timer = setTimeout(() => {
        setShowSnackbar(false);
        // When using this component,
        // need to reset show state as false using onClose
        onClose?.();
      }, delay + 300);
    } else if (!delayable && show && message && message !== "") {
      setShowSnackbar(true);
    } else {
      setShowSnackbar(false);
    }

    return () => {
      clearTimeout(timer);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, message]);

  const generateIcon = (type: any) => {
    switch (type) {
      case "error":
        return <Danger />;
      case "warning":
        return <Exclamation />;
      default:
        return <Checklist />;
    }
  };

  return (
    <Container
      data-testid={`${type}-snackbar`}
      delay={delay}
      type={type}
      show={showSnackbar}
      {...rest}>
      {generateIcon(type)}
      <NotificationText data-testid={`${dataTestId}-message`}>{message}</NotificationText>
      {type === "success" && undoable && <SuccessOption onClick={onUndo}>Undo</SuccessOption>}
      {actionButton}
      {rightMessage ? (
        <RightMessage data-testid={`${dataTestId}-right-message`} onClick={onClickRightMessage}>
          {rightMessage}
        </RightMessage>
      ) : (
        <>
          <Cross onClick={onClose} />
        </>
      )}
    </Container>
  );
}

Snackbar.defaultProps = {
  show: false,
  undoable: false,
  type: "success",
  onUndo: () => {},
  onClose: () => {},
  message: "",
  delay: 2500,
  delayable: true,
  rightMessage: null,
  onClickRightMessage: () => {},
};

export default Snackbar;
